import React, { useEffect, useState } from "react";
import styled from "styled-components";

const TableWrapper = styled.div`
  padding: 4px 8px;
  color: ${({ theme }) => theme.colors.gray1200};
  box-shadow: 0 12px 32px 0px ${({ theme }) => theme.colors.gray500};
`;

// Component that fetches the compatible libraries tables from github
// and renders the tables
const SupportedLibrariesTable = ({ json, type }) => {
  const [tableData, setTableData] = useState(null);
  
  // Used in place of componentDidMount
  // Empty array as second arg = gets called only once after mounting
  useEffect(() => {
    const fetchJSON = () => {
      fetch(json)
        .then(response => response.json())
        .then(data => {
          setTableData(data);
        });
    };
    fetchJSON();
  }, [json]);
  // Becuase rehypeReact only supports strings as props,
  // need to keep the table mappings in the component
  const tableTypeMappings = {
    Python: {
      headings: ["Library", "Version (Py3)", "Version (Edge)", "Description"],
      columns: ["python_3_version", "python_edge_version", "description"],
      filter: "python_3_version"
    },
    "Python-2": {
      headings: [
        "Library",
        "Version (Py2.7)",
        "Version (Py3)",
        "Description"
      ],
      columns: ["python_2_version", "python_3_version", "description"],
      filter: "python_2_version"
    },
    Edge: {
      headings: ["Library", "Version (Py3)", "Version (Edge)", "Description"],
      columns: ["python_3_version", "python_edge_version", "description"],
      filter: "python_edge_version"
    },
    Edge_new: {
      headings: ["Library", "Version (Py3)", "Version (Edge)", "Description"],
      columns: ["python_3_version", "python_edge_version_new", "description"],
      filter: "python_edge_version_new"
    },
    R: {
      headings: ["Library", "Version", "Description"],
      columns: ["r_3_version", "description"],
      filter: "r_3_version"
    }
  };
  const tableMapping = tableTypeMappings[type];
  return (
    <TableWrapper>
      <table>
        <thead>
          <tr>
            {tableMapping.headings.map(heading => (
              <th key={`${type}-${heading}`}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData &&
            tableData
              .filter(
                row =>
                  row[tableMapping.filter] && row[tableMapping.filter] !== "-"
              ).sort((rowA, rowB) => {
                if(rowA.package_name < rowB.package_name) {return -1;}
                if(rowA.package_name > rowB.package_name) { return 1; }
                return 0;
              })
              .map(row => {
                return (
                  <tr key={`${type}-${row.package_name}`}>
                    <td>
                      <a href={row.link} target="_blank" rel="noreferrer">
                        {row.package_name}
                      </a>
                    </td>
                    {tableMapping.columns.map(column => {
                      return (
                        <td key={`${type}-${row.package_name}-${row[column]}`}>
                          {row[column]}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
        </tbody>
      </table>
    </TableWrapper>
  );
};

SupportedLibrariesTable.defaultProps = {
  json: "https://mode.github.io/runtimes/python.json",
  type: "Python"
};

export default SupportedLibrariesTable;
